<div class="body">
  <div class="main mt-5 mb-5 h-full">
    <input type="checkbox" id="chk" aria-hidden="true" />
    <div
      class="absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-full p-4 mt-8 md:p-3"
    >
      <img
        class="w-40 h-10"
        src="/assets/images/logo.png"
        alt="logo"
        aria-hidden="true"
      />
    </div>
    <div class="signup">
      <form [formGroup]="registerForm" (ngSubmit)="onRegister()">
        <label aria-hidden="true" (click)="openSignup()">Sign up</label>

        <div class="m-5">
          <input
            type="text"
            formControlName="name"
            id="name"
            placeholder="Enter Name"
            class="w-full rounded-md border border-[#8c05e6] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
          />
          <div
            *ngIf="
              registerForm.get('name')?.touched &&
              registerForm.get('name')?.hasError('required')
            "
          >
            <small class="text-red-500">Name is required.</small>
          </div>
          <div
            *ngIf="
              registerForm.get('name')?.touched &&
              registerForm.get('name')?.hasError('minlength')
            "
          >
            <small class="text-red-500"
              >Name must be at least 3 characters long.</small
            >
          </div>
        </div>

        <!-- <div class="m-5">
          <input
            type="number"
            formControlName="mobile"
            id="Number"
            maxlength="10"
            placeholder="Enter Mobile number"
            class="w-full rounded-md border border-[#8c05e6] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
          />
          <div
            *ngIf="
              registerForm.get('mobile')?.touched &&
              registerForm.get('mobile')?.hasError('required')
            "
          >
            <small class="text-red-500">Mobile Number is required.</small>
          </div>
          <div
            *ngIf="
              registerForm.get('mobile')?.touched &&
              registerForm.get('mobile')?.hasError('minlength')
            "
          >
            <small class="text-red-500"
              >Mobile number must be exactly 10 digits.</small
            >
          </div>
          <div
            *ngIf="
              registerForm.get('mobile')?.touched &&
              registerForm.get('mobile')?.hasError('pattern')
            "
          ></div>
        </div> -->

        
   <!-- Mobile Number Field with Conditional Button/Icon -->
<div class="m-5 relative">
  <input
    type="number"
    formControlName="mobile"
    id="mobile"
    maxlength="10"
    placeholder="Enter Mobile number"
    [readonly]="isMobileVerified" 
    class="w-full rounded-md border border-[#8c05e6] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
  />
  
  <!-- Show "Send OTP" button only if mobile is not verified -->
  <button
    *ngIf="!isMobileVerified"
    type="button"
    (click)="sendWhatsappOtp(registerForm.value.mobile)"
    class="bttn absolute right-0    top-1/2 transform -translate-y-1/2 px-2 py-1 bg-[#8c05e6] text-white rounded-md hover:bg-[#6a64f1]"
  >
    Send OTP
  </button>

  <!-- Show verified icon if mobile is verified -->
  <div
    *ngIf="isMobileVerified"
    class="absolute right-0 top-1/2 transform -translate-y-1/2 px-2 py-1 text-green-500"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M5 13l4 4L19 7"
      ></path>
    </svg>
  </div>

  <!-- Error Messages -->
  <div
    *ngIf="
      registerForm.get('mobile')?.touched &&
      registerForm.get('mobile')?.hasError('required')
    "
  >
    <small class="text-red-500">Mobile Number is required.</small>
  </div>
  <div
    *ngIf="
      registerForm.get('mobile')?.touched &&
      (registerForm.get('mobile')?.hasError('minlength') ||
        registerForm.get('mobile')?.hasError('pattern'))
    "
  >
    <small class="text-red-500">Mobile number must be exactly 10 digits.</small>
  </div>
</div>

<!-- OTP Input Component -->
<div *ngIf="showOtpComponent && !isMobileVerified" class="m-5">
  <ng-otp-input
    #ngOtpInput
    (onInputChange)="onOtpChange($event)"
    [config]="config"
    class="flex justify-center space-x-2"
  ></ng-otp-input>
  <button
    type="button"
    (click)="verifyOtp()"
    class="mt-4 px-4 py-2 bg-[#8c05e6] text-white rounded-md hover:bg-[#6a64f1]"
  >
    Verify OTP
  </button>
</div>


        <div class="m-5">
          <input
            type="email"
            formControlName="email"
            id="email"
            placeholder="Enter Email"
            class="w-full rounded-md border border-[#8c05e6] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
          />
          <div
            *ngIf="
              registerForm.get('email')?.touched &&
              registerForm.get('email')?.hasError('required')
            "
          >
            <small class="text-red-500">Email is required.</small>
          </div>
          <div
            *ngIf="
              registerForm.get('email')?.touched &&
              registerForm.get('email')?.hasError('email')
            "
          >
            <small class="text-red-500">Please enter a valid email.</small>
          </div>
        </div>

        <div class="m-5">
          <input
            type="password"
            formControlName="password"
            id="password"
            placeholder="Enter Password"
            class="w-full rounded-md border border-[#8c05e6] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
          />
          <div
            *ngIf="
              registerForm.get('password')?.touched &&
              registerForm.get('password')?.hasError('required')
            "
          >
            <small class="text-red-500">Password is required.</small>
          </div>
          <div
            *ngIf="
              registerForm.get('password')?.touched &&
              registerForm.get('password')?.hasError('minlength')
            "
          >
            <small class="text-red-500"
              >Password must be at least 6 characters long.</small
            >
          </div>
        </div>

        <div class="m-5">
          <input
            type="password"
            formControlName="password_confirmation"
            id="password_confirmation"
            placeholder="Enter Confirm Password"
            class="w-full rounded-md border border-[#8c05e6] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
          />
          <div
            *ngIf="
              registerForm.get('password_confirmation')?.touched &&
              registerForm.get('password_confirmation')?.hasError('required')
            "
          >
            <small class="text-red-500"
              >Password confirmation is required.</small
            >
          </div>
          <div
            *ngIf="
              registerForm.get('password_confirmation')?.touched &&
              registerForm.get('password_confirmation')?.hasError('minlength')
            "
          >
            <small class="text-red-500"
              >Password confirmation must be at least 6 characters long.</small
            >
          </div>
        </div>

        <div class="m-6">
          <input
            id="checkbox-1"
            formControlName="accept"
            type="checkbox"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
          />
          I agree to the
          <a href="#" class="text-blue-600 hover:underline"
            >terms and conditions</a
          >
        </div>

        <button type="submit" [disabled]="registerForm.invalid">Sign up</button>
      </form>
    </div>

    <div [ngClass]="{ login1: isLogin === true, 'sign-up': isLogin === false }">
      <form [formGroup]="LoginForm" (ngSubmit)="onLogin()">
        <label (click)="openLogin()" aria-hidden="true" class="text-white"
          >Login</label
        >
        <div class="m-5">
          <input
            type="text"
            formControlName="email_mobile"
            id="email"
            placeholder="Enter email or mobile"
            class="w-full rounded-md border border-[#8c05e6] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
          />
        </div>
        <div class="m-5">
          <input
            type="password"
            formControlName="password"
            id="password"
            placeholder="Enter Password"
            class="w-full rounded-md border border-[#8c05e6] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
          />
          <div
            *ngIf="
              LoginForm.get('password')?.touched &&
              LoginForm.get('password')?.hasError('required')
            "
          >
            <small class="text-red-500">Password is required.</small>
          </div>
          <div
            *ngIf="
              LoginForm.get('password')?.touched &&
              LoginForm.get('password')?.hasError('minlength')
            "
          >
            <small class="text-red-500"
              >Password must be at least 6 characters long.</small
            >
          </div>
          <a  class="text-white flex justify-end mr-2">forget password? <span class="text-blue-700 underline cursor-pointer" (click)="forgetPassword()">Click </span></a>
        </div>
        <div class="m-6">
          <input
            id="checkbox-2"
            formControlName="terms"
            type="checkbox"
            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
          />
          I agree to the
          <a class="text-white hover:underline">terms and conditions</a>
        </div>

        <button type="submit">Login</button>
      </form>
    </div>
  </div>
</div>
